import { Helmet } from 'react-helmet';
import './style.css';
import images from 'assets/images';
import CountdownTimer from '../../components/CountDownTimer';
import type { ICommonProps } from '../../types/propTypes';
import { Common } from '../../utils/constants';
import CardValidationModal from './CardValidationModal';
import { useStationDetails } from './hooks/StationDetailsHook';
import TariffDetails from './TariffDetails';

const StationDetails = (props: ICommonProps) => {
    const {
        t,
        stationDetails,
        defaultLocationImageURL,
        showCardValidationModal,
        holding,
        selectedConnector,
        connectorId,
        showModal,
        setSelectedConnector,
        setConnectorId,
        handleHideTariffModal,
        backToHome,
        toggleCardValidationModal,
        startHold,
        stopHold,
        showTariffBreakDownDetailsModal,
        checkTariffAvailability,
        handleSelectConnector,
    } = useStationDetails(props);

    return (
        <>
            <Helmet>
                <title>{t<string>('stationDetails.title')}</title>
            </Helmet>
            {stationDetails && Object.keys(stationDetails).length > 0 ? (
                <>
                    <div className="container-fluid p-0 station-details">
                        <div className="img-div">
                            <img
                                className="station-img"
                                src={stationDetails.charge_location_image || defaultLocationImageURL}
                                alt="Station Details"
                            />
                            <button
                                title={t<string>('stationDetails.button.back')}
                                type="button"
                                className="btn btn-icon pr-0 btn-outline-primary back-button"
                                onClick={() => backToHome()}
                                data-testid="back-btn"
                            >
                                <img
                                    className="icon back-button-icon"
                                    src={images.backArrowSVG}
                                    alt={t<string>('stationDetails.button.back')}
                                />
                            </button>
                        </div>
                        <div className="row no-gutters justify-content-between">
                            <div className="col-xs-12 col-md-6 sub-title-div">
                                <h2 className="sub-title">{stationDetails.charge_station_name}</h2>
                            </div>
                        </div>
                        <div className="row no-gutters justify-content-between">
                            <div className="col-xs-12 cost-div">
                                <h6 className="details-title">{t<string>('stationDetails.label.address')}</h6>
                                &nbsp;
                                <span>{`${stationDetails.charge_location_address}`}</span>
                            </div>
                        </div>
                        {stationDetails.charge_location_amenities && (
                            <div className="row no-gutters justify-content-between details-div">
                                <div className="col-12 padding-left-20">
                                    <h6 className="details-title">{t<string>('stationDetails.label.amenities')}</h6>
                                </div>
                                <div className="col-12 padding-left-20">
                                    {stationDetails.charge_location_amenities.map((amenity) => {
                                        return (
                                            <img
                                                src={amenity.image}
                                                className="amenity-img"
                                                alt={amenity.name}
                                                key={amenity.id}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                        <div className="row no-gutters justify-content-between charge-station-div">
                            <div className={`col-12 charge-station ${holding ? 'blurred' : ''}`}>
                                <div className="station-title-div">
                                    <div className="station-name text-truncate">
                                        {stationDetails.charge_station_name}
                                    </div>
                                    <div className="station-status-div">
                                        <div className="station-status-badge">
                                            <span
                                                className="badge badge-info"
                                                style={{
                                                    background: stationDetails.charge_station_status.color,
                                                }}
                                            >
                                                {stationDetails.charge_station_status &&
                                                    stationDetails.charge_station_status.name}
                                            </span>
                                        </div>
                                        <div className="float-right">
                                            <img
                                                src={
                                                    stationDetails.charge_station_status.name === 'Unknown'
                                                        ? images.greyChargerIcon
                                                        : stationDetails.charge_station_status.image
                                                }
                                                className="charger-img"
                                                alt="charger"
                                            ></img>
                                        </div>
                                    </div>
                                </div>
                                <div className="container mt-2">
                                    <div className="connectors">
                                        {holding && (
                                            <div className="spinner" style={{ top: '50%' }}>
                                                <CountdownTimer
                                                    holding={holding}
                                                    onComplete={checkTariffAvailability}
                                                />
                                            </div>
                                        )}
                                        <div className="row">
                                            {stationDetails.connectors &&
                                                stationDetails.connectors.map((connector) => {
                                                    return (
                                                        <div className="col-6 mb-3" key={connector.id}>
                                                            <div
                                                                className={`charging-card mt-2 d-flex flex-sm-row flex-column ${
                                                                    selectedConnector === connector.id && !holding
                                                                        ? 'selected'
                                                                        : ''
                                                                } ${holding ? 'holding' : ''}  ${
                                                                    selectedConnector === connector.id && holding
                                                                        ? 'border-on-hold'
                                                                        : ''
                                                                }
             `}
                                                                onClick={
                                                                    stationDetails.charge_station_status.code ===
                                                                    Common.ChargeStationStatus.AVAILABLE
                                                                        ? () => handleSelectConnector(connector.id)
                                                                        : undefined
                                                                }
                                                                style={{
                                                                    position: 'relative',
                                                                }}
                                                            >
                                                                <div
                                                                    className={
                                                                        !holding ? 'connector-img' : 'connector-holding'
                                                                    }
                                                                >
                                                                    <img
                                                                        src={connector.connector_image}
                                                                        style={{ height: '20px', width: '20px' }}
                                                                        className="charging-icon"
                                                                        alt="charger"
                                                                    />
                                                                </div>

                                                                <div className="charging-content">
                                                                    <h6
                                                                        style={{
                                                                            letterSpacing: '0.3px',
                                                                        }}
                                                                    >
                                                                        {connector.title}
                                                                    </h6>
                                                                    <span className={!holding ? 'rate' : ''}>
                                                                        {connector.voltage &&
                                                                            `${t(
                                                                                'stationDetails.tariffDetailsModal.upto',
                                                                            )} ${connector.voltage.replace(/\s*\(kW\)/i, 'kW')}`}
                                                                    </span>

                                                                    <a
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setSelectedConnector(0);
                                                                            showTariffBreakDownDetailsModal(true);
                                                                            setConnectorId(connector.id);
                                                                        }}
                                                                        className="d-flex align-items-center 
                                    justify-content-center 
                                    justify-content-sm-start 
                                    flex-sm-row flex-column 
                                    flex-column-reverse mt-2"
                                                                    >
                                                                        <img
                                                                            src={images.plusIconSVG}
                                                                            className="plus-icon"
                                                                            alt="Plus Icon"
                                                                        />
                                                                        <span className="pricing-text">
                                                                            {t<string>('stationDetails.label.pricing')}
                                                                        </span>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                    <div className="text-center my-3">
                                        {stationDetails.charge_station_status.code ===
                                            Common.ChargeStationStatus.AVAILABLE && (
                                            <button
                                                className={`charging-button px-4 fw-bold ${
                                                    selectedConnector === 0 ? 'disabled' : ''
                                                }`}
                                                aria-label="Hold to Charge"
                                                onMouseDown={startHold}
                                                onTouchStart={startHold}
                                                onMouseUp={stopHold}
                                                onTouchEnd={stopHold}
                                                onMouseLeave={stopHold}
                                                onTouchCancel={stopHold}
                                                disabled={selectedConnector === 0}
                                            >
                                                {t<string>('stationDetails.button.holdToCharge')}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {showCardValidationModal && (
                        <CardValidationModal
                            t={t}
                            showModal={showCardValidationModal}
                            onHide={() => {
                                toggleCardValidationModal(false);
                            }}
                        />
                    )}
                </>
            ) : (
                <></>
            )}

            {showModal && (
                <TariffDetails
                    showModal={showModal}
                    connectorId={connectorId}
                    onHide={handleHideTariffModal}
                    details={stationDetails}
                />
            )}
        </>
    );
};

export default StationDetails;
